<app-navbar></app-navbar>
<div class="container-fluid">
    <!-- Filtros -->
    <div class="card shadow-sm filtros-modernas border-0 mb-4">
        <div class="card-header d-flex align-items-center rounded-top">
            <i class="fas fa-search fs-5 me-2 text-white"></i>
            <h2 class="fw-bold">Vistorias Negativas</h2>
        </div>
        <div class="card-body">
            <!-- Linha com botão de filtro à esquerda e controles de paginação/itens por página à direita -->
            <div class="row mt-3" *ngIf="!erro">
                <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
                    <!-- Botões Filtrar e Exportar Excel -->
                    <div class="d-flex gap-2">
                        <button class="btn btn-info btn-sm" type="button" (click)="toggleFiltros()">
                            <i class="fas fa-filter me-1"></i> Filtrar
                        </button>
                    </div>

                    <!-- Período -->
                    <div class="d-flex align-items-center gap-2 me-3">
                        <input class="form-control form-control-sm period-input" type="date"
                            [(ngModel)]="filtroDataInicio" />
                        <span>até</span>
                        <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim"
                            (change)="onFiltroDataFimChange()" />
                        <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
                            <i class="fas fa-sync-alt me-1"></i> Recarregar
                        </button>
                    </div>

                    <!-- Itens por página + Paginação -->
                    <div class="d-flex align-items-center gap-2 ms-auto">
                        <label class="mb-0 small">Itens:</label>
                        <select id="tamanhoPaginaSelect" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
                            (ngModelChange)="alterarTamanhoPagina($event)">
                            <option [value]="5">5</option>
                            <option [value]="10">10</option>
                            <option [value]="25">25</option>
                            <option [value]="50">50</option>
                            <option [value]="100">100</option>
                        </select>

                        <span class="page-info small">
                            Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}} itens)
                        </span>

                        <!-- Botões -->
                        <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()"
                            [disabled]="paginaAtual <= 1">
                            <i class="fas fa-chevron-left"></i>
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
                            [disabled]="paginaAtual >= totalPaginas">
                            <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row mt-2" *ngIf="showFiltros">
                <!-- <div class="col-md-3">
                    <label class="form-label">Status</label>
                    <select class="form-select" [(ngModel)]="filtroStatus">
                        <option value="">Todos</option>
                        <option value="EmAndamento">EmAndamento</option>
                        <option value="Concluida">Concluido</option>
                        <option value="Retornar">Retornar</option>
                        <option value="Negada">Negado</option>
                        <option value="Validado">Validado</option>
                        <option value="Invalido">Invalido</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Matrícula</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroMatricula"
                        placeholder="Matrícula do consumidor" />
                </div> -->
                <div class="col-md-3">
                    <label class="form-label">Nº Vistoria</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroNumeroVistoria"
                        placeholder="Nº Vistoria" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Nome Consumidor</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor"
                        placeholder="Nome do consumidor" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">CPF</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">CNPJ</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">CEP</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Número</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroNumero"
                        placeholder="Número (logradouro)" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Logradouro</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Bairro</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Cidade</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Estado</label>
                    <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
                </div>
                <div class="col-12 mt-2 d-flex gap-2">
                    <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
                    <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
                </div>
            </div>
        </div>
    </div>

    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
        <p style="color: white"> Processando, por favor aguarde... </p>
    </ngx-spinner>

    <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
        <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
    </div>
    <div *ngIf="!carregando && !erro && negativasFiltradas.length === 0"
        class="alert alert-warning d-flex align-items-center gap-2">
        <i class="bi bi-folder-x"></i>
        Nenhuma negativa encontrada para o filtro selecionado.
    </div>
    <!-- Tabela de negativas (igual ao Vistoria pendentes) -->
    <div class="table-responsive" *ngIf="!carregando && !erro && negativasFiltradas.length > 0">
        <table class="table table-bordered table-hover align-middle">
            <thead class="table-light">
                <tr>
                    <th>Data</th>
                    <th style="min-width: 110px;">Nº Vistoria</th>
                    <th>Consumidor</th>
                    <th style="min-width: 130px;">CPF/CNPJ</th>
                    <th style="min-width: 120px;">Tipo Vistoria</th>
                    <th>Status</th>
                    <th>Endereço</th>
                    <th>Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let n of negativasFiltradas; let i = index; trackBy: trackByNegativa"
                    [class]="i % 2 === 0 ? 'linha-par' : 'linha-impar'">
                    <td>
                        <span class="text-primary fw-bold">
                            {{ getTipoServico(n) === 'recadastro' ? (n.dataHoraInicio | date:'dd/MM/yyyy') :
                            (n.dataHoraInicio | date:'dd/MM/yyyy') }}
                        </span>
                    </td>
                    <td>
                        <span class=" n-vistoria" title="{{ formatNumeroOS(n) }}">{{ formatNumeroOS(n) }}</span>
                    </td>
                    <td>
                        <span class="fw-bold text-dark">{{ n.nomeConsumidor || 'Não informado' }}</span>
                    </td>
                    <td>
                        <span *ngIf="n.tipoUtilizacao?.toLowerCase() === 'DOMICILIAR'">
                            {{ maskCpf(n.cpf) || 'SEM DADOS' }}
                        </span>
                        <span *ngIf="n.tipoUtilizacao?.toLowerCase() !== 'DOMICILIAR' && n.tipoUtilizacao">
                            {{ maskCnpj(n.cnpj) || 'SEM DADOS' }}
                        </span>
                        <span *ngIf="!n.tipoUtilizacao" class="sem-dados-campo">-</span>
                    </td>
                    <td>
                        <span class="badge"
                            [ngClass]="getTipoServico(n) === 'recadastro' ? 'recadastro-badge' : 'cadastro-badge'">
                            {{ getTipoServico(n) === 'recadastro' ? 'Recadastro' : 'Cadastro' }}
                        </span>
                    </td>
                    <td>
                        <span class="badge badge-negada">
                            <i class="fas fa-times"></i>
                            {{ n.status || 'Pendente' }}
                        </span>
                    </td>
                    <td>
                        <span class="text-muted">{{ getEnderecoCompleto(n) }}</span>
                    </td>
                    <td>
                        <button class="btn btn-outline-primary btn-sm" (click)="verDetalhes(n)">
                            <i class="bi bi-eye me-1"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Controles de Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPaginas > 1">
        <div class="text-muted">
            <small>
                Mostrando {{((paginaAtual - 1) * tamanhoPagina) + 1}} -
                {{Math.min(paginaAtual * tamanhoPagina, totalItens)}} de {{totalItens}} registros
            </small>
        </div>
        <nav aria-label="Navegação de páginas">
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item" [class.disabled]="paginaAtual === 1">
                    <button class="page-link" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1">
                        <span aria-hidden="true">&laquo;</span>
                    </button>
                </li>
                <li class="page-item" [class.disabled]="paginaAtual === 1">
                    <button class="page-link" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">
                        <span aria-hidden="true">&lsaquo;</span>
                    </button>
                </li>
                <li class="page-item" *ngFor="let pagina of obterPaginas()" [class.active]="pagina === paginaAtual">
                    <button class="page-link" (click)="irParaPagina(pagina)">
                        {{ pagina }}
                    </button>
                </li>
                <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
                    <button class="page-link" (click)="proximaPagina()" [disabled]="paginaAtual === totalPaginas">
                        <span aria-hidden="true">&rsaquo;</span>
                    </button>
                </li>
                <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
                    <button class="page-link" (click)="irParaPagina(totalPaginas)"
                        [disabled]="paginaAtual === totalPaginas">
                        <span aria-hidden="true">&raquo;</span>
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</div>

<!-- Modal de detalhes do serviço -->
<div class="modal fade show" tabindex="-1"
    [ngStyle]="{display: negativaDetalhes  ? 'flex' : 'none', background: 'rgba(0,0,0,0.4)', alignItems: 'center', justifyContent: 'center'}"
    *ngIf="negativaDetalhes">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content" #conteudoModal>
            <div class="modal-header bg-gradient-info text-white">
                <h5 class="modal-title">
                    <i class="bi bi-file-earmark-text me-2"></i>
                    Detalhes da Vistoria
                </h5>
                <button type="button" class="btn-close" (click)="fecharModalDetalhes()"></button>
            </div>
            <div class="modal-body">
                <form class="form px-2 py-2">

                    <div class="mb-3">
                        <div class="p-3 rounded bg-gradient-info d-flex align-items-center">
                            <i class="fas fa-search fs-4 me-3"></i>
                            <div>
                                <div class="small">Vistoria</div>
                                <div class="h5 fw-bold mb-0">n° {{ formatNumeroOS(negativaDetalhes) }}</div>
                            </div>
                        </div>
                    </div>

                    <fieldset>
                        <legend class="mb-2">Dados do Consumidor</legend>
                        <div class="grid-2 mb-2">
                            <div
                                *ngIf="getTipoServico(negativaDetalhes) === 'recadastro' && negativaDetalhes.matricula">
                                <label>Matrícula</label>
                                <input type="text" [value]="negativaDetalhes.matricula" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nome do Consumidor</label>
                                <input type="text" [value]="negativaDetalhes.nomeConsumidor || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>
                                    <ng-container
                                        *ngIf="negativaDetalhes.tipoUtilizacao?.toLowerCase() === 'DOMICILIAR'; else cnpjLabel">
                                        CPF
                                    </ng-container>
                                    <ng-template #cnpjLabel>CNPJ</ng-template>
                                </label>
                                <input type="text"
                                    [value]="negativaDetalhes.tipoUtilizacao?.toLowerCase() === 'DOMICILIAR' ? maskCpf(negativaDetalhes.cpf) : maskCnpj(negativaDetalhes.cnpj)"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-4 mb-2">
                            <div *ngIf="negativaDetalhes.email">
                                <label>Email</label>
                                <input type="text" [value]="negativaDetalhes.email || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Telefone</label>
                                <input type="text" [value]="maskTelefone(negativaDetalhes.telefone)" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Ciclo de Leitura</label>
                                <input type="text" [value]="negativaDetalhes.cicloDeLeitura || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Número Imóvel</label>
                                <input type="text" [value]="negativaDetalhes.numeroImovel || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-4 mb-2">
                            <div>
                                <label>Referência</label>
                                <input type="text" [value]="negativaDetalhes.referencia || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Data Cadastro</label>
                                <input type="text" [value]="negativaDetalhes.dataHoraInicio | date: 'dd/MM/yyyy HH:mm'"
                                    readonly class="campo-readonly" />
                            </div>
                            <div>
                                <label>Loja/Loc</label>
                                <input type="text" [value]="negativaDetalhes.lojLoc || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Concessão Expediente</label>
                                <input type="text" [value]="negativaDetalhes.concessaoExpediente || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-3 mb-2">
                            <div>
                                <label>Sistema de Abastecimento</label>
                                <input type="text" [value]="negativaDetalhes.sistemaAbastecimento || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Tipo de Abastecimento</label>
                                <input type="text" [value]="negativaDetalhes.tipoAbastecimento || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Tipo Utilização</label>
                                <input type="text" [value]="negativaDetalhes.tipoUtilizacao || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset *ngIf="negativaDetalhes.possuiDebito">
                        <legend class="mb-2">Débito</legend>
                        <div>
                            <label>Possui Débito</label>
                            <input type="text" [value]="negativaDetalhes.possuiDebito ? 'Sim' : 'Não'" readonly
                                class="campo-readonly" />
                        </div>
                        <div class="grid-2 mb-2"
                            *ngIf="negativaDetalhes.valorDebito || negativaDetalhes.dataInicioDebito">
                            <div *ngIf="negativaDetalhes.valorDebito">
                                <label>Valor do Débito</label>
                                <input type="text"
                                    [value]="negativaDetalhes.valorDebito | currency:'BRL':'symbol':'1.2-2'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div *ngIf="negativaDetalhes.dataInicioDebito">
                                <label>Data Início Débito</label>
                                <input type="text" [value]="negativaDetalhes.dataInicioDebito | date:'dd/MM/yyyy'"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Endereço</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Logradouro:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.logradouro || negativaDetalhes.logradouro || '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>Número:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.numero || negativaDetalhes.numero || '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>Bairro:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.bairro || negativaDetalhes.bairro || '-'"
                                    readonly>
                            </div>
                        </div>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Cidade:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.cidade || negativaDetalhes.cidade || '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>Estado:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.estado || negativaDetalhes.estado || '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>CEP:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.cep || negativaDetalhes.cep || '-'" readonly>
                            </div>
                        </div>
                        <div class="grid-1 mb-2"
                            *ngIf="negativaDetalhes.endereco?.complemento || negativaDetalhes.complemento">
                            <div>
                                <label>Complemento:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.endereco?.complemento || negativaDetalhes.complemento || '-'"
                                    readonly>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset
                        *ngIf="negativaDetalhes.numeroHidrometro || negativaDetalhes.marcacao || negativaDetalhes.seloReloj || negativaDetalhes.seloVirola || negativaDetalhes.ramal || negativaDetalhes.direto !== undefined || negativaDetalhes.haCisterna !== undefined || negativaDetalhes.haReservatorioElevado !== undefined || negativaDetalhes.tipoEconomia || negativaDetalhes.haPiscina !== undefined">
                        <legend class="mb-2">ÁGUA</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Nº Hidrômetro</label>
                                <input type="text" [value]="negativaDetalhes.numeroHidrometro || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Marcação</label>
                                <input type="text" [value]="negativaDetalhes.marcacao || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Selo Reloj.</label>
                                <input type="text" [value]="negativaDetalhes.seloReloj || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Selo Virola</label>
                                <input type="text" [value]="negativaDetalhes.seloVirola || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Ramal</label>
                                <input type="text" [value]="negativaDetalhes.ramal || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Direto</label>
                                <input type="text"
                                    [value]="negativaDetalhes.direto === undefined ? '-' : (negativaDetalhes.direto ? 'Sim' : 'Não')"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-1 mb-2">
                            <fieldset *ngIf="negativaDetalhes.haCisterna !== undefined">
                                <h4>Cisterna</h4>
                                <label>Há cisterna?</label>
                                <input type="text" [value]="negativaDetalhes.haCisterna ? 'Sim' : 'Não'" readonly
                                    class="campo-readonly" />
                                <div
                                    *ngIf="negativaDetalhes.haCisterna && negativaDetalhes.capacidadeCisternaInformada">
                                    <label>Capacidade Informada</label>
                                    <input type="text" [value]="negativaDetalhes.capacidadeCisternaInformada" readonly
                                        class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.haCisterna && negativaDetalhes.observacoesCisterna">
                                    <label>Observações</label>
                                    <textarea readonly class="campo-readonly"
                                        rows="2">{{ negativaDetalhes.observacoesCisterna }}</textarea>
                                </div>
                            </fieldset>

                            <fieldset *ngIf="negativaDetalhes.haReservatorioElevado !== undefined">
                                <h4>Reservatório Elevado</h4>
                                <label>Há Reservatórios Elevados?</label>
                                <input type="text" [value]="negativaDetalhes.haReservatorioElevado ? 'Sim' : 'Não'"
                                    readonly class="campo-readonly" />
                                <div
                                    *ngIf="negativaDetalhes.haReservatorioElevado && negativaDetalhes.capacidadeReservatorioElevadoInformada">
                                    <label>Capacidade Informada</label>
                                    <input type="text" [value]="negativaDetalhes.capacidadeReservatorioElevadoInformada"
                                        readonly class="campo-readonly" />
                                </div>
                                <div
                                    *ngIf="negativaDetalhes.haReservatorioElevado && negativaDetalhes.observacoesReservatorioElevado">
                                    <label>Observações</label>
                                    <textarea readonly class="campo-readonly"
                                        rows="2">{{ negativaDetalhes.observacoesReservatorioElevado }}</textarea>
                                </div>
                            </fieldset>

                            <fieldset *ngIf="negativaDetalhes.haPiscina !== undefined">
                                <h4>Piscina</h4>
                                <label>Existe Piscina?</label>
                                <input type="text" [value]="negativaDetalhes.haPiscina ? 'Sim' : 'Não'" readonly
                                    class="campo-readonly" />
                                <div *ngIf="negativaDetalhes.haPiscina && negativaDetalhes.dimensoesPiscina">
                                    <label>Dimensões:</label>
                                    <input type="text" [value]="negativaDetalhes.dimensoesPiscina" readonly
                                        class="campo-readonly" />
                                </div>
                            </fieldset>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Economias</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Tipos de Economias</label>
                                <input type="text" [value]="negativaDetalhes.tipoEconomia || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div *ngIf="negativaDetalhes.dUnica">
                                <label>Sub Categoria</label>
                                <input type="text" [value]="negativaDetalhes.dUnica" readonly class="campo-readonly" />
                            </div>
                            <div>
                                <label>Número de Economias</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeEconomias || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <!-- DOMICILIAR -->
                        <div class="grid-4 mb-2"
                            *ngIf="negativaDetalhes.tipoEconomia === 'DOMICILIAR' && (negativaDetalhes.numeroDeQuartos || negativaDetalhes.numeroDeSalas || negativaDetalhes.numeroWcPav)">
                            <div *ngIf="negativaDetalhes.numeroDeQuartos">
                                <label>Nº Quartos</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeQuartos" readonly
                                    class="campo-readonly" />
                            </div>
                            <div *ngIf="negativaDetalhes.numeroDeSalas">
                                <label>Nº Salas</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeSalas" readonly
                                    class="campo-readonly" />
                            </div>
                            <div *ngIf="negativaDetalhes.numeroWcPav">
                                <label>Nº WC/PAV</label>
                                <input type="text" [value]="negativaDetalhes.numeroWcPav" readonly
                                    class="campo-readonly" />
                            </div>
                            <div *ngIf="negativaDetalhes.numeroDeBoxes">
                                <label>Nº Boxes</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeBoxes" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <!-- COMERCIO -->
                        <div class="grid-3 mb-2" *ngIf="negativaDetalhes.tipoEconomia === 'COMERCIO'">
                            <div>
                                <label>Nº Salas/Lojas/Quartos</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeQuartos" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Tipo Comércio</label>
                                <input type="text" [value]="negativaDetalhes.tipoComercio" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Alunos</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeAlunos" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Boxes</label>
                                <input type="text" [value]="negativaDetalhes.numeroDeBoxes" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Banheiro</label>
                                <input type="text" [value]="negativaDetalhes.banheiros" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Área (m²)</label>
                                <input type="text" [value]="negativaDetalhes.areaMetroQuadrado" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <!-- Indústria -->
                        <div class="grid-3 mb-2" *ngIf="negativaDetalhes.tipoEconomia === 'INDUSTRIA'">
                            <div>
                                <label>Tipo Indústria</label>
                                <input type="text" [value]="negativaDetalhes.tipoIndustria" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Área (m²)</label>
                                <input type="text" [value]="negativaDetalhes.areaMetroQuadrado" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset
                        *ngIf="negativaDetalhes.haColetor !== undefined || negativaDetalhes.coletor || negativaDetalhes.gap || negativaDetalhes.rio || negativaDetalhes.valao || negativaDetalhes.focaFiltro || negativaDetalhes.vala || negativaDetalhes.sumidouro || negativaDetalhes.tipoValaValao">
                        <legend class="mb-2">ESGOTO</legend>
                        <div *ngIf="negativaDetalhes.haColetor !== undefined">
                            <label>Tem coletor?</label>
                            <input type="text" [value]="negativaDetalhes.haColetor ? 'Sim' : 'Não'" readonly
                                class="campo-readonly" />
                        </div>

                        <div
                            *ngIf="negativaDetalhes.haColetor && (negativaDetalhes.coletor || negativaDetalhes.gap || negativaDetalhes.rio || negativaDetalhes.valao || negativaDetalhes.focaFiltro || negativaDetalhes.vala || negativaDetalhes.sumidouro)">
                            <label>Efluente encaminhado para:</label>
                            <div class="grid-4 mb-2">
                                <div *ngIf="negativaDetalhes.coletor === 'true'">
                                    <label>Coletor</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.gap === 'true'">
                                    <label>GAP</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.rio === 'true'">
                                    <label>RIO</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.valao === 'true'">
                                    <label>VALÃO</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.focaFiltro === 'true'">
                                    <label>Fossa/Filtro</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.vala === 'true'">
                                    <label>Vala</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="negativaDetalhes.sumidouro === 'true'">
                                    <label>Sumidouro</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                            </div>
                            <div *ngIf="negativaDetalhes.tipoValaValao">
                                <label>A vala ou valão é de:</label>
                                <input type="text" [value]="negativaDetalhes.tipoValaValao" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">FOTOS DO LOCAL</legend>
                        <div class="fotos-grid mb-2">
                            <div class="foto-item" *ngFor="let foto of negativaDetalhes.fotos">
                                <div class="foto-wrapper"
                                    (click)="abrirModalFoto(getFullImageUrl(foto.url)); $event.stopPropagation()">
                                    <img [src]="getFullImageUrl(foto.url)" alt="Foto do Local" class="foto-local"
                                        (click)="abrirModalFoto(getFullImageUrl(foto.url))"
                                        [ngStyle]="{'transform': 'rotate(' + getPhotoRotation(foto.url) + 'deg)'}" />
                                </div>
                                <div class="foto-actions mt-2">
                                    <a *ngIf="foto?.latitude && foto?.longitude"
                                        [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude"
                                        target="_blank" class="btn btn-outline-success btn-sm">
                                        <i class="bi bi-geo-alt-fill"></i> Mapa
                                    </a>

                                    <div class="rotate-buttons">
                                        <button type="button" class="btn btn-light btn-sm rotate-btn"
                                            (click)="rotatePhoto(foto.url, -90)" title="Girar esquerda">
                                            <i class="bi bi-arrow-counterclockwise"></i>
                                        </button>
                                        <button type="button" class="btn btn-light btn-sm rotate-btn"
                                            (click)="rotatePhoto(foto.url, 90)" title="Girar direita">
                                            <i class="bi bi-arrow-clockwise"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!negativaDetalhes.fotos?.length" class="alert alert-warning">
                            Nenhuma foto disponível.
                        </div>
                    </fieldset>

                    <fieldset *ngIf="negativaDetalhes.outrasInformacoes">
                        <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
                        <div>
                            <label>Descrição da Conclusão</label>
                            <textarea readonly class="campo-readonly"
                                rows="6">{{ negativaDetalhes.outrasInformacoes }}</textarea>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">MOTIVO DA NEGATIVA</legend>
                        <div class="grid-1 mb-2">
                            <div>
                                <label>Descrição da Negativa</label>
                                <textarea readonly class="campo-readonly"
                                    rows="4">{{ negativaDetalhes.motivoNegativa }}</textarea>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Localização</legend>
                        <div class="grid-2 mb-2">
                            <div>
                                <label>Início</label>
                                <div *ngIf="negativaDetalhes.latitudeInicio && negativaDetalhes.longitudeInicio"
                                    class="coordenadas-label">
                                    <span class="badge bg-light text-dark">Lat: {{ negativaDetalhes.latitudeInicio }} |
                                        Lng: {{
                                        negativaDetalhes.longitudeInicio }}</span>
                                </div>
                                <a *ngIf="negativaDetalhes.latitudeInicio && negativaDetalhes.longitudeInicio"
                                    [href]="'https://www.google.com/maps?q=' + negativaDetalhes.latitudeInicio + ',' + negativaDetalhes.longitudeInicio"
                                    target="_blank" class="btn btn-outline-success btn-sm ms-1">
                                    <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                                </a>
                                <span *ngIf="!negativaDetalhes.latitudeInicio || !negativaDetalhes.longitudeInicio"
                                    class="text-muted">Sem
                                    localização</span>
                                <div class="mt-2" *ngIf="negativaDetalhes.dataHoraInicio">
                                    <label>Data/Hora Início</label>
                                    <input type="text"
                                        [value]="negativaDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss'" readonly
                                        class="campo-readonly" />
                                </div>
                            </div>
                            <div>
                                <label>Fim</label>
                                <div *ngIf="negativaDetalhes.latitudeFim && negativaDetalhes.longitudeFim"
                                    class="coordenadas-label">
                                    <span class="badge bg-light text-dark">Lat: {{ negativaDetalhes.latitudeFim }} |
                                        Lng:
                                        {{
                                        negativaDetalhes.longitudeFim }}</span>
                                </div>
                                <a *ngIf="negativaDetalhes.latitudeFim && negativaDetalhes.longitudeFim"
                                    [href]="'https://www.google.com/maps?q=' + negativaDetalhes.latitudeFim + ',' + negativaDetalhes.longitudeFim"
                                    target="_blank" class="btn btn-outline-danger btn-sm ms-1">
                                    <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                                </a>
                                <span *ngIf="!negativaDetalhes.latitudeFim || !negativaDetalhes.longitudeFim"
                                    class="text-muted">Sem
                                    localização</span>
                                <div class="mt-2" *ngIf="negativaDetalhes.dataHoraFim">
                                    <label>Data/Hora Fim</label>
                                    <input type="text"
                                        [value]="negativaDetalhes.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss'" readonly
                                        class="campo-readonly" />
                                </div>
                            </div>
                        </div>
                        <div class="map-container">
                            <div id="map-cadastro"></div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Acompanhante</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Nome:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.nomeAcompanhante || '-'" readonly>
                            </div>
                            <div>
                                <label>CPF:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="negativaDetalhes.cpfAcompanhante ? maskCpf(negativaDetalhes.cpfAcompanhante) : '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>Telefone do Acompanhante</label>
                                <input type="text" [value]="maskTelefone(negativaDetalhes.telefoneAcompanhante)"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>
                        <div>
                            <label>Assinatura do Acompanhante:</label>
                            <div class="signature-container">
                                <img *ngIf="negativaDetalhes.assinaturaAcompanhante?.url || negativaDetalhes.assinaturaAcompanhante"
                                    [src]="getFullImageUrl(negativaDetalhes.assinaturaAcompanhante?.url || negativaDetalhes.assinaturaAcompanhante)"
                                    alt="Assinatura do Acompanhante" class="signature-image"
                                    (click)="abrirModalFoto(negativaDetalhes.assinaturaAcompanhante?.url || negativaDetalhes.assinaturaAcompanhante)">
                                <div *ngIf="!negativaDetalhes.assinaturaAcompanhante?.url && !negativaDetalhes.assinaturaAcompanhante"
                                    class="sem-dados-campo">
                                    Não informado
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Dados do Vistoriador</legend>
                        <div class="grid-2 mb-2">
                            <div>
                                <label>Nome do Vistoriador</label>
                                <input type="text" [value]="negativaDetalhes.nomeVistoriante || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Data da Vistoria</label>
                                <input type="text"
                                    [value]="getTipoServico(negativaDetalhes) === 'recadastro' ? (negativaDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm') : (negativaDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm')"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>
                        <div class="grid-1 vistoriador-foto mb-2">
                            <div
                                *ngIf="negativaDetalhes.fotoVistoriante && negativaDetalhes.fotoVistoriante !== 'URL_PADRAO_SEM_IMAGEM'">
                                <label>Foto do Vistoriador</label>
                                <div class="foto-vistoriador"
                                    (click)="abrirModalFoto(negativaDetalhes.fotoVistoriante)">
                                    <img [src]="getFullImageUrl(negativaDetalhes.fotoVistoriante)"
                                        alt="Foto do Vistoriador" class="foto-vistoriador">
                                </div>
                            </div>
                            <div *ngIf="!negativaDetalhes.fotoVistoriante || negativaDetalhes.fotoVistoriante === 'URL_PADRAO_SEM_IMAGEM'"
                                class="alert alert-warning">
                                Foto não disponível
                            </div>
                        </div>
                        <div>
                            <label>Assinatura do Vistoriador:</label>
                            <div class="signature-container">
                                <img *ngIf="negativaDetalhes.assinaturaVistoriador || negativaDetalhes.assinaturaVistoriante?.url"
                                    [src]="getFullImageUrl(negativaDetalhes.assinaturaVistoriador || negativaDetalhes.assinaturaVistoriante?.url)"
                                    alt="Assinatura do Vistoriador" class="signature-image"
                                    (click)="abrirModalFoto(negativaDetalhes.assinaturaVistoriador || negativaDetalhes.assinaturaVistoriante?.url)">
                                <div *ngIf="!negativaDetalhes.assinaturaVistoriador && !negativaDetalhes.assinaturaVistoriante?.url"
                                    class="sem-dados-campo">
                                    Não informado
                                </div>
                            </div>
                        </div>
                    </fieldset>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger me-2" (click)="exportarServicoParaPDF()">
                    <i class="bi bi-file-earmark-pdf-fill me-1"></i> Exportar PDF
                </button>
                <button type="button" class="btn btn-secondary" (click)="fecharModalDetalhes()">Fechar</button>
            </div>
        </div>
    </div>
</div>
<!-- Modal para visualização da foto ampliada -->
<div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto" (click)="fecharModalFoto()">
    <div class="modal-foto-content" (click)="$event.stopPropagation()">
        <button type="button" class="btn-close-foto" (click)="fecharModalFoto()">
            <i class="fas fa-times"></i>
        </button>
        <img [src]="getFullImageUrl(fotoSelecionada)" alt="Foto Ampliada" class="foto-ampliada"
            [ngStyle]="{'transform': 'rotate(' + rotacaoFoto + 'deg)'}">
    </div>
</div>